import { useMutation, useQueryClient } from "@tanstack/react-query";
import { replaceReminderInListCaches } from "web_myplann/Api/Reminders/remindersCacheUtils";
import {
	patchRemindersIdV2,
	type UpdateReminderResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useReminderCancelSnoozeMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<UpdateReminderResponseDTO, Error, string>({
		mutationFn: processResponse((id: string) =>
			patchRemindersIdV2({ snoozedUntil: null }, Number(id)),
		),
		onSuccess: (data) => {
			replaceReminderInListCaches(queryClient, data);
		},
	});
};
